const BuildingItemHook = {
  mounted() {
    let root = this.el.closest('[data-list]');
    this.scrolling = false;
    this.mapOpen = this.el.dataset.mapOpen == 'true';
    this.observing = false;

    let buildingId = this.el.dataset.buildingId;

    let scrollTarget;
    let elOffset;

    if (window.innerWidth < 1024) {
      scrollTarget = [document.documentElement, document.body];
      elOffset = $(this.el).offset().top - 60;
    } else {
      scrollTarget = [document.getElementById('building-list-container')];
      elOffset =
        $(this.el).offset().top -
        $('#building-list-container').offset().top +
        $('#building-list-container').scrollTop() -
        10;
    }

    this.handleEvent(`building_open:${buildingId}`, ({ scroll }) => {
      document.getElementById('buildings-map').dispatchEvent(
        new CustomEvent('focus-building-marker', {
          detail: { buildingId: buildingId },
        }),
      );

      document.getElementById('building-list').dispatchEvent(
        new CustomEvent('focus-building', {
          detail: { id: buildingId, scroll: true },
        }),
      );

      if (scroll || window.innerWidth < 1024) {
        $(scrollTarget).animate({ scrollTop: elOffset }, 300);
      }
    });

    if (window.innerWidth < 1024) {
      // On mobile we need to make marker active when listing item in current view.
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((elem) => {
            if (elem.isIntersecting) {
              if (this.scrolling) {
                this.scrolling = false;
              } else {
                document.getElementById('buildings-map').dispatchEvent(
                  new CustomEvent('focus-building-marker', {
                    detail: {
                      buildingId: buildingId,
                    },
                  }),
                );
              }
            }
          });
        },
        {
          root: root,
          threshold: 0.9,
        },
      );

      if (this.mapOpen) {
        this.observign = true;
        this.observer.observe(this.el);
      }
    } else {
      // On desktop we just need to hover marker.
      this.el.addEventListener('mouseenter', () => {
        document.getElementById('buildings-map').dispatchEvent(
          new CustomEvent('hover-building-marker', {
            detail: {
              buildingId: buildingId,
            },
          }),
        );
      });
    }
  },

  updated() {
    this.mapOpen = this.el.dataset.mapOpen == 'true';

    let open = this.el.dataset.open == 'true';

    if (open) {
      document.getElementById('buildings-map').dispatchEvent(
        new CustomEvent('focus-building-marker', {
          detail: {
            buildingId: this.el.dataset.buildingId,
          },
        }),
      );
    }

    if (window.innerWidth < 1024) {
      if (this.observing) {
        if (!this.mapOpen) {
          this.observing = false;
          this.observer.unobserve(this.el);
        }
      } else {
        if (this.mapOpen) {
          this.observing = true;
          this.observer.observe(this.el);
        }
      }
    }
  },

  beforeDestroy() {
    if (this.observing) {
      this.observer.unobserve(this.el);
    }
  },
};

export default BuildingItemHook;
